var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormGroup, FormControl, Validators } from "@angular/forms";
var SeedingReportFormGroup = /** @class */ (function (_super) {
    __extends(SeedingReportFormGroup, _super);
    function SeedingReportFormGroup() {
        var _this = this;
        var controlSet = {
            startDate: new FormControl(null, Validators.required),
            endDate: new FormControl(null, Validators.required),
            crop: new FormControl(),
            containerType: new FormControl(),
            substrate: new FormControl()
        };
        _this = _super.call(this, controlSet) || this;
        _this._startDate = controlSet.startDate;
        _this._endDate = controlSet.endDate;
        _this._crop = controlSet.crop;
        _this._containerType = controlSet.containerType;
        _this._substrate = controlSet.substrate;
        return _this;
    }
    Object.defineProperty(SeedingReportFormGroup.prototype, "startDateFormControl", {
        get: function () {
            return this._startDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeedingReportFormGroup.prototype, "endDateFormControl", {
        get: function () {
            return this._endDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeedingReportFormGroup.prototype, "cropFormControl", {
        get: function () {
            return this._crop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeedingReportFormGroup.prototype, "containerTypeFormControl", {
        get: function () {
            return this._containerType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeedingReportFormGroup.prototype, "substrateFormControl", {
        get: function () {
            return this._substrate;
        },
        enumerable: true,
        configurable: true
    });
    return SeedingReportFormGroup;
}(FormGroup));
export { SeedingReportFormGroup };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/seeding-report-form/seeding-report-form-group.ts.pre-build-optimizer.js